// @flow
import React, { useState } from 'react';

import styles from './tab.css';

type TabPropsType = {
  title: string;
  className?: any;
}

const Tab = ({
  title,
  className,
  ...props,
}: TabPropsType) => {
  const { selected, onClick } = props;

  return (
    <div
      className={`
        ${styles.tabContainer}
        ${className ? className : ''}
      `}
      onClick={() => onClick()}
    >
      <p
        className={`
          ${styles.tabTitle}
          ${selected ? styles.selected : styles.unSelected}
        `}
      >
        {title}
      </p>
    </div>
  );
}

export default Tab;



// WEBPACK FOOTER //
// ./src/scripts/components/Tab/index.jsx